export const ECOSYSTEMS_BASE_PATH = {
  innovation: '/innovation',
  school: '/school',
  nomad: '/nomad',
};
